import { TableColumn } from "./dataInterface";

export const entryFormTableColumn: TableColumn = {
  title: "エントリーフォーム一覧",
  detail: false,
  detailTitle: "エントリーフォーム詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "エントリーフォーム登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [
    {
      name: "削除",
      width: "40px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "entry_form_edit_flg",
      name: "質問追加・削除",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "140px",
      sort: false,
      tableValue: "edit_check",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: false,
      editId: "high_rank_company_id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_id",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "high_rank_company",
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: "text",
      addMessage: "",
    },
    {
      key: "product_id",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "product",
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "product",
      addMessage: "",
    },
    {
      key: "entry_sale_company_id",
      name: "エントリーパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "company",
      addMessage: "",
    },
    {
      key: "entry_sale_company_name",
      name: "エントリーパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_option",
      name: "質問",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: "product_option",
      addMessage: "",
    },
  ],
  spTier: 'sp_first',
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "チャットアプリ連携一覧",
      subTableColumnLength: "chat_app_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "160px",
      subTableDetail: true,
      subTableDetailTitle: "チャットアプリ連携詳細",
      subTableAdd: true,
      subTableAddTitle: "チャットアプリ連携追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: true,
      subTableEditTitle: "チャットアプリ連携編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "entry_form_id",
          name: "エントリーフォームID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "sns_type",
          name: "チャットアプリ連携タイプ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "sns_id",
          name: "チャットアプリ連携ID",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "sns_haeder",
          name: "チャットアプリ連携時ヘッダー",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※末尾に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
        {
          key: "sns_footer",
          name: "チャットアプリ連携時フッター",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※先頭に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "チャット連携-依存質問-選択肢一覧",
          subTableColumnLength: "chat_app_depend_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "130px",
          subTableDetail: false,
          subTableDetailTitle: "依存質問-選択肢詳細",
          subTableAdd: true,
          subTableAddTitle: "依存質問-選択肢追加",
          subTableAddTitleWidth: "130px",
          subTableEdit: false,
          subTableEditTitle: "依存質問-選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
          tableFunction: [
            {
              name: "削除",
              auth: ["マスターアカウント", "スタッフアカウント"],
            },
          ],
          subDataColumn: [
            {
              key: "depend_option_name",
              name: "依存質問名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
            {
              key: "depend_option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "質問一覧",
      subTableColumnLength: "option_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "60px",
      subTableDetail: false,
      subTableDetailTitle: "質問一覧詳細",
      subTableAdd: true,
      subTableAddTitle: "質問一覧編集・追加",
      subTableAddLabel: "編集・追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "質問一覧編集",
      subTableEditDirect: true,
      subTableEditDirectKey: "id",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "product_id",
          add: false,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "product_id",
          add: false,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "option_name",
          name: "質問名",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "sns_send",
          name: "チャットアプリ連携",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "required_optional",
          name: "必須フラグ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_type",
          name: "質問区分",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_default_value",
          name: "デフォルト値",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "change_value_conf",
          name: "入力値の編集",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_comment",
          name: "説明",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_flg",
          name: "フラグ設定",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_select",
          name: "選択肢",
          table: false,
          tableValue: null,
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "選択肢一覧",
          subTableColumnLength: "option_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "100px",
          subTableDetail: false,
          subTableDetailTitle: "選択肢詳細",
          subTableAdd: false,
          subTableAddTitle: "選択肢追加",
          subTableAddTitleWidth: "100px",
          subTableEdit: false,
          subTableEditTitle: "選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "依存プラン一覧",
          subTableColumnLength: "option_depend_plan_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "100px",
          subTableDetail: false,
          subTableDetailTitle: "依存プラン詳細",
          subTableAdd: false,
          subTableAddTitle: "依存プラン追加",
          subTableAddTitleWidth: "100px",
          subTableEdit: false,
          subTableEditTitle: "依存プラン編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "service_plan_name",
              name: "依存プラン",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "依存コンテンツ一覧",
          subTableColumnLength: "option_depend_content_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "130px",
          subTableDetail: false,
          subTableDetailTitle: "依存コンテンツ詳細",
          subTableAdd: false,
          subTableAddTitle: "依存コンテンツ追加",
          subTableAddTitleWidth: "130px",
          subTableEdit: false,
          subTableEditTitle: "依存コンテンツ編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "service_content_name",
              name: "依存コンテンツ",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "依存質問-選択肢一覧",
          subTableColumnLength: "option_depend_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "130px",
          subTableDetail: false,
          subTableDetailTitle: "依存質問-選択肢詳細",
          subTableAdd: false,
          subTableAddTitle: "依存質問-選択肢追加",
          subTableAddTitleWidth: "130px",
          subTableEdit: false,
          subTableEditTitle: "依存質問-選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "depend_option_name",
              name: "依存質問名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
            {
              key: "depend_option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
  ],
};
